import { UsergroupAddOutlined } from '@ant-design/icons';

// Campaign Team — field mobilizers organized by geography who canvass and file
// voter-issue field reports with photos. (Distinct from Ground Operations agents
// and from the dashboard Team RBAC.)
const campaignTeam = {
  id: 'group-campaign-team',
  title: 'Campaign Team',
  type: 'group',
  children: [
    {
      id: 'campaign-team',
      title: 'Campaign Team',
      type: 'item',
      url: '/campaign-team',
      icon: UsergroupAddOutlined
    }
  ]
};

export default campaignTeam;
